import { AddressCell } from '@/components/ui'
import { InsightConfigurationType } from '@/types/dashboard-types'

interface GenericLocationDrilldownProps {
  configuration: InsightConfigurationType
  address?: string
  latitude?: number
  longitude?: number
  markerFields: Record<string, string>
  companyId?: number
}
const GenericLocationDrilldown = ({
  configuration,
  address,
  latitude,
  longitude,
  markerFields,
  companyId,
}: GenericLocationDrilldownProps) => {
  if (!latitude || !longitude) {
    return address || 'N/A'
  }

  return {
    id: 'generic-location-map',
    address: address || 'N/A',
    lat: latitude,
    lng: longitude,
    companyId,
    title: `${configuration.title}: Event Location`,
    markerContent: (
      <div>
        {Object.entries(markerFields)
          .filter(([, v]) => !!v)
          .map(([k, v]) => (
            <div key={k}>
              {k}: {v}
            </div>
          ))}
      </div>
    ),
  } as AddressCell
}

export default GenericLocationDrilldown
